import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Star, Plus, ShoppingCart } from 'lucide-react';
import { products } from '../data/products';
import { useCart } from '../context/CartContext';
export function Products() {
  const {
    addItem
  } = useCart();
  return <section id="shop" className="py-24 bg-brand-cream" data-id="element-160">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-161">
        <div className="text-center mb-16" data-id="element-162">
          <span className="text-brand-orange font-medium tracking-widest uppercase text-sm" data-id="element-163">
            Onze Collectie
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-dark mt-4 mb-6" data-id="element-164">
            Puur &amp; Authentiek
          </h2>
          <p className="text-brand-gray max-w-2xl mx-auto" data-id="element-165">
            Zorgvuldig geselecteerde pepers, gedroogd en gemalen met behoud van
            de authentieke Surinaamse smaak.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-166">
          {products.map(product => <div key={product.id} className="group relative bg-white rounded-2xl p-4 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col" data-id="element-167">
              {product.tag && <span className="absolute top-6 left-6 z-10 bg-brand-dark text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-168">
                  {product.tag}
                </span>}

              <Link to={`/product/${product.slug}`} className="block relative aspect-square overflow-hidden rounded-xl mb-6 bg-gray-100" data-id="element-169">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-170" />

                {/* Quick Add Overlay */}
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6 pointer-events-none" data-id="element-171">
                  <button onClick={e => {
                e.preventDefault();
                addItem(product);
              }} className="bg-white text-brand-dark px-6 py-3 rounded-full font-medium flex items-center gap-2 hover:bg-brand-red hover:text-white transition-colors transform translate-y-4 group-hover:translate-y-0 duration-300 pointer-events-auto" data-id="element-172">
                    <ShoppingCart size={18} data-id="element-173" />
                    Snel Toevoegen
                  </button>
                </div>
              </Link>

              <div className="flex-grow flex flex-col" data-id="element-174">
                <div className="flex items-center gap-1 mb-2" data-id="element-175">
                  <Star size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-176" />
                  <span className="text-sm font-medium" data-id="element-177">{product.rating}</span>
                  <span className="text-sm text-brand-gray" data-id="element-178">
                    ({product.reviews})
                  </span>
                </div>

                <Link to={`/product/${product.slug}`} className="hover:text-brand-red transition-colors" data-id="element-179">
                  <h3 className="font-serif font-semibold text-lg text-brand-dark mb-2 leading-tight" data-id="element-180">
                    {product.name}
                  </h3>
                </Link>

                <div className="mt-auto flex items-center justify-between pt-4" data-id="element-181">
                  <span className="text-xl font-bold text-brand-dark" data-id="element-182">
                    €{product.price.toFixed(2)}
                  </span>
                  <button onClick={() => addItem(product)} aria-label={`${product.name} toevoegen aan winkelwagen`} className="w-10 h-10 rounded-full bg-brand-cream flex items-center justify-center text-brand-dark hover:bg-brand-red hover:text-white hover:scale-110 transition-all" data-id="element-183">
                    <Plus size={20} data-id="element-184" />
                  </button>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-16" data-id="element-185">
          <Link to="/shop" className="inline-flex items-center gap-2 border-2 border-brand-dark text-brand-dark px-8 py-3 rounded-full font-medium hover:bg-brand-dark hover:text-white transition-colors duration-300" data-id="element-186">
            Bekijk alle producten
          </Link>
        </div>
      </div>
    </section>;
}